import PropTypes from 'prop-types';
import { classNames } from '../../utils/common';
import AvatarIcon from '../../assets/components/AvatarIcon';
import { Image } from '@chakra-ui/react';
import { useMemo } from 'react';

const Avatar = ({ src, alt = '', size = 'w-20 h-20', className, name }) => {
  const invalidSrc = useMemo(
    () => !src || src.includes('profile.webp') || src.includes('undefined'),
    [src],
  );

  const initial = name ? name.charAt(0).toUpperCase() : null;

  const fallback = initial ? (
    <div className={classNames(className, size, 'rounded-full bg-primary flex items-center justify-center text-white font-bold select-none')}>
      {initial}
    </div>
  ) : (
    <AvatarIcon className={classNames(className, size)} />
  );

  return (
    <Image
      src={!invalidSrc && src}
      alt={alt}
      className={classNames(className, size, 'rounded-full')}
      fallback={fallback}
    />
  );
};

Avatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
};

export default Avatar;
